/**
 * Closed-week score calculation status for admin UI (history + legacy fallback).
 */

import { LeagueService, TeamService } from '../services/firebaseService';

function calculatedAtMillis(calculatedAt) {
  if (!calculatedAt) return 0;
  if (calculatedAt.toDate) return calculatedAt.toDate().getTime();
  if (calculatedAt.seconds) return calculatedAt.seconds * 1000;
  return 0;
}

/**
 * @param {object} week - Season week object
 * @returns {{ calculated: true, calculatedAt: *, scope: * }|null}
 */
export function getScoreStatusFromWeekHistory(week) {
  if (!week.scoreCalculationHistory || week.scoreCalculationHistory.length === 0) {
    return null;
  }
  const sortedHistory = [...week.scoreCalculationHistory].sort(
    (a, b) => calculatedAtMillis(b.calculatedAt) - calculatedAtMillis(a.calculatedAt)
  );
  const mostRecent = sortedHistory[0];
  return {
    calculated: true,
    calculatedAt: mostRecent.calculatedAt,
    scope: mostRecent.scope
  };
}

async function checkScoresCalculatedLegacy(seasonId, weekNumber) {
  try {
    const leagues = await LeagueService.getAllLeagues();
    for (const league of leagues) {
      try {
        const teams = await TeamService.getTeams(league.id, seasonId);
        for (const team of teams) {
          if (
            team.weeklyScores &&
            team.weeklyScores[weekNumber.toString()] !== undefined
          ) {
            return {
              calculated: true,
              calculatedAt: null
            };
          }
        }
      } catch {
        continue;
      }
    }
    return { calculated: false };
  } catch (error) {
    console.error('Error checking scores:', error);
    return { calculated: false };
  }
}

/**
 * @param {string} seasonId
 * @param {Array<object>} closedWeeks - weeks with isOpenForPredictions === false
 * @returns {Promise<Record<number, { calculated: boolean, calculatedAt?: *, scope?: * }>>}
 */
export async function buildClosedWeekScoreStatusMap(seasonId, closedWeeks) {
  const scoreStatus = {};
  for (const week of closedWeeks) {
    const fromHistory = getScoreStatusFromWeekHistory(week);
    if (fromHistory) {
      scoreStatus[week.weekNumber] = fromHistory;
    } else {
      scoreStatus[week.weekNumber] = await checkScoresCalculatedLegacy(
        seasonId,
        week.weekNumber
      );
    }
  }
  return scoreStatus;
}
